export default "__VITE_ASSET__91fc9c17__"